import React from "react";
import { User, Calendar, PauseCircle } from "lucide-react";
import { cardCls, labelCls } from "./tokens";
import { StatusBadge, SLABadge } from "./Badges";

/**
 * TaskCard — task summary used in queues.
 * Variants: standard / overdue / on_hold (via slaStatus + onHold prop)
 */
export default function TaskCard({
  title,
  saleNumber,
  customer,
  assignee,
  dueLabel,
  slaStatus = "on_track",
  slaRemaining,
  taskStatus = "in_progress",
  onHold = false,
  holdReason,
  onClick,
  testId,
}) {
  return (
    <div
      onClick={onClick}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      data-testid={testId || `task-card-${(saleNumber || title || "x").toLowerCase()}`}
      className={`${cardCls} p-4 flex flex-col gap-3 ${
        onClick ? "cursor-pointer hover:border-onedesk-primary transition-colors" : ""
      }`}
    >
      {/* Header: title + status */}
      <div className="flex items-start justify-between gap-3">
        <div className="flex flex-col gap-1 min-w-0">
          {saleNumber && (
            <span className={labelCls}>{saleNumber}</span>
          )}
          <h4 className="font-bold text-base text-onedesk-textPrimary truncate">
            {title}
          </h4>
          {customer && (
            <p className="font-medium text-sm text-onedesk-textSecondary truncate">
              {customer}
            </p>
          )}
        </div>
        <StatusBadge status={taskStatus} />
      </div>

      {/* Meta row */}
      <div className="flex flex-wrap items-center gap-x-4 gap-y-2 text-xs">
        {assignee && (
          <span className="inline-flex items-center gap-1.5 font-medium text-onedesk-textSecondary">
            <User className="h-3.5 w-3.5" strokeWidth={2.25} />
            {assignee}
          </span>
        )}
        {dueLabel && (
          <span className="inline-flex items-center gap-1.5 font-medium text-onedesk-textSecondary">
            <Calendar className="h-3.5 w-3.5" strokeWidth={2.25} />
            Due {dueLabel}
          </span>
        )}
      </div>

      {/* Footer: SLA + Hold */}
      <div className="flex items-center justify-between gap-3 border-t border-onedesk-border pt-3">
        <SLABadge status={slaStatus} remaining={slaRemaining} />
        {onHold && (
          <span className="inline-flex items-center gap-1.5 rounded-od-input border border-onedesk-border bg-onedesk-bg px-3 py-1 text-xs font-bold uppercase tracking-wider text-onedesk-textSecondary">
            <PauseCircle className="h-3.5 w-3.5" strokeWidth={2.25} />
            {holdReason || "On Hold"}
          </span>
        )}
      </div>
    </div>
  );
}
